export default __webpack_public_path__ + "static/media/b16.3e7af9ea.jpg";